import {Construtor} from './construtor';
import {Processo} from './processo';
import {SetorPontoFisico} from './setor-ponto-fisico';

export class ProcessoSetor implements Construtor<ProcessoSetor> {

  public idProcessoSetor: number;
  public setorPontoFisico: SetorPontoFisico;
  public idProcessoCliente: number;
  public processo: Processo;
  public selecionado: boolean;
  public alterado: boolean;
  public visible: boolean;

  constructor(object?: any) {
    this.visible = false;
    this.processo = new Processo();
    this.setorPontoFisico = new SetorPontoFisico();

    if (object !== undefined) {
      if (object instanceof (ProcessoSetor)) {
        this.copyObject(object);
      } else if (object instanceof (Processo)) {
        this.processo = object;
      } else {
        this.parseFromJson(object);
      }

      if (!this.modeloCompleto()) {
        return null;
      }
    }
  }

  set IdProcessoSetor(id: any) {
    this.idProcessoSetor = id;
  }

  set SetorPontoFisico(setorPontoFisico: any) {
    this.setorPontoFisico = setorPontoFisico;
  }

  set IdProcessoCliente(id: any) {
    this.idProcessoCliente = id;
  }

  set Processo(processo: any) {
    this.processo = new Processo(processo);
  }

  parseFromJson(processoSetor: any): void {
    this.IdProcessoSetor = processoSetor.idProcessoSetor;
    this.SetorPontoFisico = processoSetor.setorPontoFisico;
    this.IdProcessoCliente = processoSetor.idProcessoCliente;
    this.Processo = processoSetor.processo;
  }

  copyObject(processoSetor: ProcessoSetor): void {
    this.idProcessoSetor = processoSetor.idProcessoSetor;
    this.setorPontoFisico = processoSetor.setorPontoFisico;
    this.idProcessoCliente = processoSetor.idProcessoCliente;
    this.processo = processoSetor.processo;
  }

  modeloCompleto(): boolean {
    return this.processo.modeloCompleto();
  }

  getNewInstance(object?: any): ProcessoSetor {
    return new ProcessoSetor(object);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/processo-setor.ts